import { render, staticRenderFns } from "./GroupDuplicate.vue?vue&type=template&id=6e51421c&scoped=true&"
import script from "./GroupDuplicate.vue?vue&type=script&lang=js&"
export * from "./GroupDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./GroupDuplicate.vue?vue&type=style&index=0&id=6e51421c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51421c",
  null
  
)

export default component.exports